import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertSharpIcon from "@mui/icons-material/MoreVertSharp";
import PaletteIcon from "@mui/icons-material/Palette";
import SaveIcon from "@mui/icons-material/Save";
import { Backdrop, SpeedDial, SpeedDialAction } from "@mui/material";
import * as React from "react";
import MovieMaker from "../../../SketchUtilities/MovieMaker/MovieMakerComponent";
import { BrushShortcutMenus } from "./BrushShortcutMenus";
import { BrushSettingsModal } from "./BrushSettingsModal"
interface navBarProps { 
  setOpenSpeedDial: (val: boolean) => void;
  openSpeedDial: boolean;
  openBrush: () => void;
  openColors: () => void;
  undo: () => void;
  redo: () => void;
  saveImage: () => void;
  newCanvas: () => void;
}

export const NavBar = (props: navBarProps) => {
  const { setOpenSpeedDial, openSpeedDial } = props;

  return (
    <div className={"mobileNavBar"} id={"topBrush"}>
      <div
        className={"navBarItem"}
        style={{ borderRight: "1px solid black", flex:"1" }}
        onClick={() => {
          props.openBrush();
        }}
      >
        <img
          style={{ width: "35px", height: "35px" }}
          src={require("../../../../../Assets/brushIcon.png")}
        />
      </div>
      <div
        className={"navBarItem"}
        style={{
          borderRight: "1px solid black", flex:"1" 
        }}
        onClick={() => {
          props.openColors();
        }}
      >
        <PaletteIcon />
      </div>
      <div
        className={"shortcutMenuItemContainer"}
        style={{ borderRight: "1px solid black"  }}
        >
        <BrushShortcutMenus/>
      </div>
      <div
        className={"navBarItem"}
        style={{ flex: 1, borderRight: "1px solid black" }}
        onClick={() => {
          props.undo();
        }}
      >
        {" "}
        <img
          style={{ width: "35px", height: "35px" }}
          src={require("../../../../../Assets/undo.svg")}
        />
      </div>
      {MovieMaker()}
      <div className="navBarItem" style={{ width:"50px", display: 'flex' }}>
        <MoreVertSharpIcon
          style={{ width:"auto"}}
          onClick={() => {
            if (!openSpeedDial) {
              setOpenSpeedDial(true);
            }
          }}
        />
        <Backdrop open={openSpeedDial} />
        <SpeedDial
          ariaLabel="SpeedDial"
          className={"navBarSpeedDial"}
          open={openSpeedDial}
          style={{ position: 'absolute', transform: "translate(-40px, -115px)" }}
        >
          <SpeedDialAction
            icon={<CloseIcon />}
            tooltipTitle={`Close`}
            onClick={() => {
              if (openSpeedDial) {
                setOpenSpeedDial(false);
              }
            }}
          />
          <SpeedDialAction
            icon={<AddIcon />}
            tooltipTitle={"New Canvas"}
            onClick={() => {
              props.newCanvas();
              if (openSpeedDial) {
                setOpenSpeedDial(false);
              }
            }}
          />
          <SpeedDialAction
            icon={<SaveIcon />}
            tooltipTitle={`Save Image`}
            onClick={() => {
              props.saveImage();
              if (openSpeedDial) {
                setOpenSpeedDial(false);
              }
            }}
          />
        </SpeedDial>
      </div>
      <BrushSettingsModal/>
    </div>
  );
};
